import React, { useRef, useCallback } from "react";
import usePortal from "react-useportal";
import { parseCSSText } from "../../../libraries/_helpers";

export const useModal = ({ onOpen, onClose, background, querySelector = 'body', ...config } = {}) => {
  const { customStyle } = config || {};

  const modalStyle = `
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 1000;
  `;

  const backgroundStyle = `
    position: fixed;
    background: ${background || "transparent"};

    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 1000;
  `;

  const modal = useRef();

  const { isOpen, togglePortal, openPortal, closePortal, Portal, portalRef } = usePortal({
    onOpen(event) {
      const { portal } = event;
      portal.current.style.cssText = background
        ? backgroundStyle
        : customStyle
          ? customStyle
          : modalStyle;
      if (onOpen) onOpen(event);
    },
    onClose(event) {
      const { portal } = event;
      portal.current.removeAttribute("style");
      if (onClose) onClose(event);
    },
    onPortalClick({ target }) {
      const clickingOutsideModal =
        modal && modal.current && !modal.current.contains(target);
      if (clickingOutsideModal) closePortal();
    },
    ...config
  });

  const ModalWithBackground = useCallback(
    props => (
      <Portal>
        <div ref={modal} style={parseCSSText(modalStyle)} {...props} />
      </Portal>
    ),
    [modalStyle]
  );

  const Modal = background ? ModalWithBackground : Portal;

  return Object.assign([openPortal, closePortal, isOpen, Modal, togglePortal], {
    Modal,
    toggleModal: togglePortal,
    openModal: openPortal,
    closeModal: closePortal,
    isOpen,
    portalRef
  });
};

export default useModal;
